import { createContext, useContext, useState } from 'react';
import { KNOWLEDGE_BASE } from '../../visitor-widget/constants/views';
import { jsx as _jsx } from "react/jsx-runtime";
const KBLibraryContext = /*#__PURE__*/createContext(undefined);
export const KBLibraryProvider = ({
  children
}) => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [originView, setOriginView] = useState(KNOWLEDGE_BASE);
  const context = {
    selectedArticle,
    setSelectedArticle,
    selectedCategory,
    setSelectedCategory,
    originView,
    setOriginView
  };
  if (typeof children === 'function') {
    return /*#__PURE__*/_jsx(KBLibraryContext.Provider, {
      value: context,
      children: children(context)
    });
  }
  return /*#__PURE__*/_jsx(KBLibraryContext.Provider, {
    value: context,
    children: children
  });
};
export const useKBLibrary = () => useContext(KBLibraryContext);
KBLibraryProvider.displayName = 'KBLibraryProvider';